export default {
  title: 'Moderation templates',
  pattern: 'Pattern',

  titles: {
    new: 'New moderation template',
    create: 'Create new moderation template',
    users: 'Users'
  },

  headers: {
    moderation: 'Moderation',
    title: 'Title',
    comment: 'Comment'
  },

  labels: {
    title: 'Title',
    name: 'Sender name',
    text: 'Text',
    type: 'Type',
    moderation: 'Moderation',
    search: 'Search',
    id: 'ID',
    owner: 'Owner',
    isActive: 'Activate or deactivate moderation template',
    check: 'Text to check',
    sendername: 'Sender name',

    filter: {
      isActive: 'Active only'
    },

    meta: {
      comment: 'Comment',
      adminComment: 'Administrator comment',
      adminCommentPrivate: 'Private administrator comment',
      resellerComment: 'Reseller comment',
      resellerCommentPrivate: 'Private reseller comment'
    }
  },

  statuses: {
    disabled: 'Not requested',
    requested: 'Requested',
    moderation: 'Moderation',
    approved: 'Approved',
    rejected: 'Rejected'
  },

  contents: {
    confirm: {
      remove: 'Delete moderation template?'
    }
  },

  errors: {
    isSms: 'Only latin characters or digits allowed, 15 symbols maximum',
    pattern: 'Pattern not passed validation'
  },

  buttons: {
    users: 'Users {count}'
  },

  hints: {
    emptyState: 'No moderation templates found',
    notFound: 'Moderation templates not found',
    check: 'Enter text to check pattern matching'
  },

  tooltips: {
    favorites: 'Mark moderation template as favorite',
    check: {
      empty: 'Enter text to validate against the pattern',
      invalid: 'Text does not match the pattern',
      valid: 'Text matches the pattern'
    },
    filter: {
      isActive: 'On - active patterns only, off - deactivated only'
    },
    isActive: {
      true: 'Activated',
      false: 'Deactivated'
    }
  },

  snackbars: {
    created: 'Moderation template successfully created.',
    updated: 'Moderation template successfully updated.',
    removed: 'Moderation template successfully removed.'
  }
}
